import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { DOUBLE_PATTERN } from "../../@auth/components/constants";
import { User } from "../../@core/data/users";
import { Employee } from "../../models/employee.model";
import { Finance } from "../../models/finance.model";
import { Person } from "../../models/person.model";
import { Catalog } from "../../models/product.model";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";
import { FinanceService } from "../../services/finance.service";
import { DialogLinkCatalogComponent } from "../dialog-link-catalog/dialog-link-catalog.component";
import { DialogLinkCustomerComponent } from "../dialog-link-customer/dialog-link-customer.component";
import { DialogLinkPersonComponent } from "../dialog-link-person/dialog-link-person.component";
import { DialogPrintFinanceComponent } from "../dialog-print-finance/dialog-print-finance.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Customer } from "../../models/customer.model";
import { CustomerService } from "../../services/customer.service";

@Component({
  selector: "ngx-dialog-finance",
  templateUrl: "dialog-finance.component.html",
  styleUrls: ["dialog-finance.component.scss"],
})
export class DialogFinanceComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() finance?: Finance;
  @Input() mode: string; //new/edit
  @Input() groupFins?: Catalog[] = [];
  @Input() persons?: Person[] = [];
  @Input() type = "receive"; //receive/issue
  @Input() employees?: Employee[];
  @Input() receipt?: Receipt;

  loading = false;
  submitted = false;

  diaForm: FormGroup;
  edited = false;
  imagesUrl = [];
  trees: Set<string> = new Set([]);

  issueDate: Date = new Date();
  saved = false;

  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";
  isEmployee: boolean = false;
  lockData: boolean = false;

  constructor(
    protected ref: NbDialogRef<DialogFinanceComponent>,
    private financeService: FinanceService,
    public customerService: CustomerService,
    private dialogService: NbDialogService,
    private fb: FormBuilder,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const noteValidators = [Validators.minLength(1), Validators.required];
    const amountValidators = [
      Validators.pattern(DOUBLE_PATTERN),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      note: ["", noteValidators],
      amount: ["", amountValidators],
      type: [],
      issueDate: [],
      isBankTransfer: [],
    });

    this.diaForm.patchValue({
      note: "",
      amount: "",
      issueDate: new Date(),
    });

    if (this.mode === "edit" && this.finance) {
      this.issueDate = this.finance.issueDate;

      if (this.finance.isPrint && !this.user.admin && !this.user.moderator) {
        this.lockData = true;
      }
    }

    if (this.finance.tags && this.finance.tags.length > 0) {
      var trees = new Set([]);
      this.finance.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("Fin");
    }

    this.isEmployee = this.finance.type === "employee" ? true : false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initNewData() {
    this.mode = "new";
    let newProd = new Finance();
    newProd.shopId = this.finance.shopId;
    this.finance = newProd;
    this.finance.isPrint = false;
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    const currentDate = new Date();
    if (
      this.issueDate.getFullYear() == currentDate.getFullYear() &&
      this.issueDate.getMonth() == currentDate.getMonth() &&
      this.issueDate.getDate() == currentDate.getDate()
    ) {
      this.finance.issueDate = currentDate;
    } else {
      let d = this.issueDate.getDate();
      let m = this.issueDate.getMonth();
      let y = this.issueDate.getFullYear();
      let h = currentDate.getHours();
      let min = currentDate.getMinutes();
      let sec = currentDate.getSeconds();
      this.finance.issueDate = new Date(y, m, d, h, min, sec, 0);
    }

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.finance.tags = tags;

    this.finance.groupId = this.finance.groupId ? this.finance.groupId : "";
    this.finance.groupName = _.find(this.groupFins, {
      id: this.finance.groupId,
    })?.title;

    this.finance.customerId = this.finance.customerId
      ? this.finance.customerId
      : "";
    this.finance.supplierId = this.finance.supplierId
      ? this.finance.supplierId
      : "";
    this.finance.employeeId = this.finance.employeeId
      ? this.finance.employeeId
      : "";

    if (this.finance.customerId) {
      this.finance.objectType = "customer";
      this.finance.objectName = "KH: " + this.finance.customerName;
    } else if (this.finance.supplierId) {
      this.finance.objectType = "supplier";
      this.finance.objectName = "KH: " + this.finance.supplierName;
    } else if (this.finance.employeeId) {
      this.finance.objectType = "employee";
      this.finance.objectName = "KH: " + this.finance.employeeName;
    } else {
      this.finance.objectType = "";
      this.finance.objectName = "";
    }

    // this.finance.objectName = this.finance.customerId
    //   ? "KH: " + this.finance.customerName
    //   : this.finance.supplierId
    //   ? "NCC: " + this.finance.supplierName
    //   : this.finance.employeeId
    //   ? "NV: " + this.finance.employeeName
    //   : "";

    if (
      this.receipt &&
      this.receipt.totalAmount < parseFloat(this.diaForm.value.amount)
    ) {
      this.showToast("warning", "Số tiền thu lơn hơn tiền bán hàng", "");
    } else {
      if (this.mode == "edit") {
        this.finance.receiveAmount = parseFloat(
          this.finance.receiveAmount.toString()
        );
        this.finance.issueAmount = parseFloat(
          this.finance.issueAmount.toString()
        );

        this.edit(this.finance);
      } else {
        this.finance.isReceive = this.type === "receive" ? true : false;
        this.finance.receiveAmount =
          this.type === "receive" ? parseFloat(this.diaForm.value.amount) : 0;
        this.finance.issueAmount =
          this.type !== "receive" ? parseFloat(this.diaForm.value.amount) : 0;

        this.create(this.finance);
      }
    }
  }

  //Control events
  selectType(value) {
    this.type = value;
  }

  selectEmployee(value) {
    console.log("selectEmployee:", value);
    if (value) {
      this.finance.customerId = "";
      this.finance.customerName = "";
      this.finance.supplierId = "";
      this.finance.supplierName = "";
      this.finance.employeeId = value.objectId;
      this.finance.employeeName = value.objectName;
      this.finance.type = value.objectId ? "employee" : "";
      this.finance.personName = value.objectName ? value.objectName : "";
    }
  }

  selectPerson() {
    this.dialogService
      .open(DialogLinkPersonComponent, {
        context: {
          header: `Xin vui lòng chọn.`,
          shopId: this.shopId,
          linkPersonId: this.finance.personId,
          persons: this.persons,
          customerId: this.finance.customerId,
          supplierId: this.finance.supplierId,
          employeeId: this.finance.employeeId,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.finance.personId = value.id;
          this.finance.personName = value.fullName ? value.fullName : "";
          this.finance.personMobile = value.mobile ? value.mobile : "";
          this.finance.personAddress = value.address ? value.address : "";
        }
      });
  }

  removePerson() {
    this.finance.personId = "";
    this.finance.personName = "";
    this.finance.personMobile = "";
    this.finance.personAddress = "";
  }

  openCatalog() {
    this.dialogService
      .open(DialogLinkCatalogComponent, {
        context: {
          header: `Xin vui lòng chọn nhóm.`,
          mode: "groupFins",
          shopId: this.shopId,
          linkCatalogId: this.finance.groupId,
          catalogs: this.groupFins,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.finance.groupId = value.id;
          this.finance.groupName = value.id !== "" ? value.title : null;
        }
      });
  }

  removeCatalog() {
    this.finance.groupId = "";
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  inputPrice = false;
  openInputPrice() {
    this.inputPrice = true;
  }
  closeInputPrice() {
    this.inputPrice = false;
  }

  private edit(item) {
    this.loading = true;
    this.submitted = true;

    this.financeService
      .update(item)
      .then((data) => {
        this.loading = false;
        this.submitted = false;
        this.setCustomerSynced();

        //this.print();
        this.ref.close(this.finance);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  private create(item) {
    this.loading = true;
    this.submitted = true;

    this.financeService
      .create(item)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.setCustomerSynced();

        //this.print();
        this.ref.close(this.finance);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  remove() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.financeService
            .delete(this.shopId, this.finance.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;

              this.finance.issueDate = new Date();
              this.finance.issueAmount = 0;
              this.finance.receiveAmount = 0;

              this.setCustomerSynced();
              this.ref.close(this.finance);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  print() {
    this.finance.noPrint++;
    this.loading = true;
    this.submitted = true;

    this.dialogService
      .open(DialogPrintFinanceComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          shop: this.shop,
          finance: this.finance,
          rePrint: false,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {
        this.financeService
          .updatePrint(this.shopId, this.finance.id, this.finance.noPrint)
          .then((result) => {
            this.loading = false;
            this.submitted = false;
            this.ref.close(this.finance);
          })
          .catch((err) => {
            this.loading = false;
            this.submitted = false;
            this.ref.close(this.finance);
          });
      });
  }

  private setCustomerSynced() {
    if (this.finance.customerId) {
      const index = _.findIndex(this.customerService.customers, {
        id: this.finance.customerId,
      });
      if (index >= 0) {
        this.customerService.customers[index].isSynced = false;
        this.customerService.updateIndexedDb(
          this.customerService.customers[index]
        );
      }
    }
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
